module.exports = __webpack_public_path__ + "static/media/cape-cod-8.b400abba.jpg";